export const getNavigatorLanguage = () => navigator.language || 'en-US';
